'use strict';
import { EwSiteApp } from '../../app/ewsiteapp.js';

EwSiteApp.controller('InstrumentWizard', ["$scope", "$http", "$attrs", "$timeout", function ($scope, $http, $attrs, $timeout) {
    $scope.getUrl = '';
    $scope.data = [];

    // Progress
    $scope.progValue = 0;

    // Scope
    $scope.showScope = true;
    $scope.selectedScope = null;

    // Types
    $scope.showTypes = false;
    $scope.selectedTypes = null;

    // Funding amount
    $scope.showFundingAmount = false;
    $scope.fundingAmount = 200000;

    // Fetch data
    $scope.getData = function () {
        if ($scope.getUrl !== '') {
            $http({
                method: 'GET',
                url: $scope.getUrl
            }).then(function (response) {
                $scope.data = response.data.data;
            }, function (response) {
                console.log(['Error', response]);
            });
        }
    };

    // Scope selected check
    $scope.scopeSelectedCheck = function (selectedScope) {
        angular.forEach($scope.data.scope, function (scope) {
            scope.selected = (scope === selectedScope);
        });

        $scope.selectedScope = selectedScope;
        $scope.scopeSelected = !!$scope.selectedScope;
    };

    // Types selected check
    $scope.typesSelectedCheck = function (selectedTypes) {
        angular.forEach($scope.data.types, function (types) {
            types.selected = (types === selectedTypes);
        });

        $scope.selectedTypes = selectedTypes;
        $scope.typesSelected = !!$scope.selectedTypes;
    };

    // Function to update funding amount when either input is adjusted
    $scope.updateFundingAmount = function (value) {
        $scope.fundingAmount = value;
    };

}]).directive('instrumentWizardContainer', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (attr.getUrl) {
                scope.getUrl = attr.getUrl;
                scope.getData();
            }
        }
    };
}).directive('progressBar', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch('progValue', function (newValue) {
                element.find('.progress-bar__icon').css('left', newValue + '%');
            });
        }
    };
});
